import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const ProjectCard = makeShortcode("ProjectCard");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>{`Projects`}</h2>
    <ProjectCard title="Spotify Clone" link="https://github.com/anushree71199/spotifyClone1" bg="linear-gradient(to right, #08b8bb 1%, #491583 100%)" mdxType="ProjectCard">
This clone was a part of #ReactChallenge and it uses React, Redux, Props, Hooks, and User Authentication. You can find the live link on my GitHub.
    </ProjectCard>
    <ProjectCard title="Mini JavaScript Projects" link="https://github.com/anushree71199/miniProject" bg="linear-gradient(to right, #4c0e81 13%, #0dacb7 100%)" mdxType="ProjectCard">
This project consists of 11 javascript projects which covers up all the basic concepts for a javascript beginner.
    </ProjectCard>
    <ProjectCard title="Breast Cancer Detector" link="https://github.com/anushree71199/Cancer_Detect" bg="linear-gradient(to right, #4c0e81 13%, #0dacb7 100%)" mdxType="ProjectCard">
This was done under #MLLearningChallenge. It uses the concept of data regression, logic regression.
    </ProjectCard>
    <ProjectCard title="Translation App" link="https://github.com/anushree71199/bananamania" bg="linear-gradient(to right, #08b8bb 1%, #491583 100%)" mdxType="ProjectCard">
This project was made by using Vanilla Js. It uses the concept of fetch APIs.
    </ProjectCard>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      